import { render, staticRenderFns } from "./SdRadio.vue?vue&type=template&id=125f7a1c&scoped=true"
import script from "./SdRadio.vue?vue&type=script&lang=js"
export * from "./SdRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125f7a1c",
  null
  
)

export default component.exports